import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
const imageCss = "iawsizs";
const Image = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const alt = I18n.t('publisher.account_settings.branding.logo');
  return <Component ref={ref} {...restProps} alt={alt} className={classNames(imageCss, props.className)} />;
});
const containerCss = "c1in0h41";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const EmptyLogoBox = () => <Container>{I18n.t('publisher.account_settings.branding.no_logo')}</Container>;
export const NonEnforcedLogoBox = () => <Container><BodyText>{I18n.t('publisher.organization.branding.logos.logo_not_used')}</BodyText></Container>;
export const LogoBox = ({
  src
}) => <Container><Image src={src} /></Container>;
LogoBox.propTypes = {
  src: PropTypes.string.isRequired
};

require("./logo_box.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./logo_box.js");